import { TypeColorNames } from '../theme/colors';
import { ThemeTypes } from '../theme/theme';
import useThemeContext from './useThemeContext';

type getThemeComponentColorType = {
  color: TypeColorNames,
  theme: ThemeTypes,
};

const getThemeComponentColor = ({ color, theme }: getThemeComponentColorType): string => {
  if (!theme.colors[color]) {
    throw new Error(`Invalid color type: ${color}!`);
  }
  return theme.colors[color];

};

const useGetThemeComponentColor = () => {
  const theme = useThemeContext();

  return (color: TypeColorNames) => getThemeComponentColor({ color, theme });
};

export { getThemeComponentColor };
export default useGetThemeComponentColor;
